import React, { useState, useEffect } from 'react';
import CSVImport from '../../components/CSVImport/CSVImport';
import ProductTable from '../../components/ProductTable/ProductTable';
import './CSVImportPage.css';

const CSVImportPage = () => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState('');

  // Fetch danh sách category từ API
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const response = await fetch('https://store.annk.info/api/category');
        if (!response.ok) throw new Error('Không thể lấy danh sách category');
        const data = await response.json();
        setCategories(data);
      } catch (error) {
        console.error('Error fetching categories:', error);
        // Mock data để test (xóa khi có API thực)
        setCategories();
        console.warn('Sử dụng mock categories - vui lòng setup API /api/category');
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, [categories]);

  const handleProductsImport = (importedProducts) => {
    setProducts(importedProducts);
    setMessage(`✓ Đã nhập ${importedProducts.length} sản phẩm`);
    setTimeout(() => setMessage(''), 3000);
  };

  const handleProductChange = (updatedProducts) => {
    setProducts(updatedProducts);
  };

  const handleDeleteProduct = (index) => {
    const updatedProducts = products.filter((_, i) => i !== index);
    setProducts(updatedProducts);
  };

  const handleSubmit = async () => {
    // Kiểm tra dữ liệu
    const errors = [];
    products.forEach((product, index) => {
      if (!product.product.trim()) errors.push(`Dòng ${index + 1}: Thiếu tên sản phẩm`);
      if (product.price <= 0) errors.push(`Dòng ${index + 1}: Giá phải > 0`);
      if (!product.url.trim()) errors.push(`Dòng ${index + 1}: Thiếu link ưu đãi`);
      if (!product.productLink?.trim()) errors.push(`Dòng ${index + 1}: Thiếu link sản phẩm`);
      if (!product.category) errors.push(`Dòng ${index + 1}: Chưa chọn danh mục`);
    });

    if (errors.length > 0) {
      setMessage(`✗ Lỗi:\n${errors.join('\n')}`);
      return;
    }

    try {
      setSubmitting(true);
      const response = await fetch('https://store.annk.info/api/product', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(products),
      });

      if (!response.ok) throw new Error('Gửi dữ liệu thất bại');
      
      const result = await response.json();
      setMessage(`✓ Gửi thành công ${result.count || products.length} sản phẩm`);
      setProducts([]);
      
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      console.error('Error submitting products:', error);
      setMessage(`✗ Lỗi: ${error.message}`);
    } finally {
      setSubmitting(false);
    }
  };

  const handleViewJSON = () => {
    const jsonStr = JSON.stringify(products, null, 2);
    console.log('JSON Products:', jsonStr);
    alert('Dữ liệu JSON đã được ghi vào console (F12)');
  };

  return (
    <div className="csv-import-page">
      <div className="page-container">
        <div className="page-header">
          <h1>Quản lý nhập sản phẩm từ CSV</h1>
          <p className="page-description">
            Nhập và quản lý danh sách sản phẩm từ CSV trước khi gửi lên hệ thống
          </p>
        </div>

        {message && (
          <div className={`message-box ${message.includes('✗') ? 'error' : 'success'}`}>
            {message}
          </div>
        )}

        <CSVImport onProductsImport={handleProductsImport} />

        {products.length > 0 && (
          <div className="products-section">
            <div className="section-header">
              <h2>
                Danh sách sản phẩm ({products.length})
              </h2>
            </div>

            <ProductTable
              products={products}
              categories={categories}
              onProductChange={handleProductChange}
              onDeleteProduct={handleDeleteProduct}
            />

            <div className="actions-footer">
              <button
                onClick={handleViewJSON}
                className="btn btn-secondary"
                disabled={submitting}
              >
                Xem JSON
              </button>
              <button
                onClick={handleSubmit}
                className="btn btn-primary"
                disabled={submitting || products.length === 0}
              >
                {submitting ? 'Đang gửi...' : 'Gửi lên server'}
              </button>
            </div>
          </div>
        )}

        {loading && <div className="loading">Đang tải danh sách category...</div>}
      </div>
    </div>
  );
};

export default CSVImportPage;
